export enum CargoPlacesControls {
  TotalWeight = 'TotalWeight',
  TotalVolumetricWeight = 'TotalVolumetricWeight',
}

export enum CargoPlaceControls {
  volumetricLength = 'volumetricLength',
  volumetricWidth = 'volumetricWidth',
  volumetricHeight = 'volumetricHeight',
  volumetricVolume = 'volumetricVolume',
  weight = 'weight',
}
